import { z } from "zod";
import { UrlSearchParamsSchema } from "@/features/discovery/index.contract.ts";
import { findFeedRowKeys } from "@wags/discovery/feeds/find-feed.contract.ts";

export const FindSearchSchema = UrlSearchParamsSchema.extend({
    dogId: z.string().trim().min(1).optional().catch(undefined),
    feedRow: z.enum(findFeedRowKeys).optional(),
});

export type FindSearch = z.infer<typeof FindSearchSchema>;
